import {
  background,
  border,
  borderRadius,
  colors,
  fontFamily,
  fontSize,
  fontWeight,
  gradient,
  headline,
  letterSpacing,
  lineHeight,
  opacityScale,
  palette,
  shadow,
  spacing,
  spacingInline,
  spacingInset,
  spacingSquish,
  spacingStack,
  text,
} from './tokens';

const theme = {
  palette,
  gradient(color) {
    const { degree, from, to } = gradient[color];
    return `linear-gradient(${degree}deg, ${from}, ${to})`;
  },
  shadow,
  borderRadius,
  opacityScale,
  spacing,
  fontFamily,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  headline,
  text,
  spacingInline,
  spacingStack,
  spacingSquish,
  colors,
  spacingInset,
  background,
  border,
};

export default theme;
